module.exports = __webpack_public_path__ + "static/media/trial1-after-10-sek-if-unanswered.8f7d86ba.mp3";